<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText:'新增版本', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          defaultExpandAll: true, // 展开全部
          column: [
            {
              label: '版本号',
              rules: [{type: 'string', required: true, message: '请填写版本号', trigger: 'blur'}],
              prop: 'no',
              row: true,
              width: '150px'
            },
            {
              label: '安卓包',
              prop: 'android_downloadList',
              display: false,
              html: true,
              formatter: function (row) {
                // el-icon-goods
                return row.android_download.length ? '<a target="_blank" href="' + row.android_download + '"><img src="images/android.png" height="60px"></a>' : '未上传'
              },
            },
            {
              label: '安卓包',
              prop: 'android_download',
              type: 'upload',
              dataType: 'string',
              loadText: '附件上传中，请稍等',
              span: 24,
              hide: true,
              slot: true,
              oss: 'ali',
            }, {
              label: 'ios地址',
              prop: 'ios_download',
              type: 'url',
              span: 24
            },
            {
              label: '下载页',
              prop: 'download_page',
              type: 'upload',
              rules: [{type: 'string', required: true, message: '请上传下载页', trigger: 'blur'}],
              listType: 'picture-img',// 单图
              filesize: 10485760, // 10MB    10*1024*1024
              oss: 'ali',
              loadText: '附件上传中，请稍等',
              span: 24
            },{
              label: '创建时间',
              prop: 'created_at',
              type: 'datetimerange',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              display: false,
            }
          ],
        }
      }
    }
  }
</script>
